import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { DiscountsRouteNames, DiscountsRoutePathNames } from '../../../../enums';
import { beforeEnter } from '../../../../routes/guards/index';

const Component = () => import('./RystLocationUserManagement.vue');

export default {
  path: buildChildURL(
    DiscountsRoutePathNames.RYST_INCENTIVES_MANAGER,
    DiscountsRoutePathNames.RYST_LOCATION_USER_MANAGEMENT,
  ),
  name: DiscountsRouteNames.RYST_LOCATION_USER_MANAGEMENT,
  component: Component,
  beforeEnter,
} as RouteRecordRaw;
